import { createHashRouter } from 'react-router-dom'
import Home from '../components/home'
import App from '../App'
import Win from '../components/window'
import Macsoftware from '../components/mac'
import Games from '../components/game'
import Details from '../components/details/Details'
import Statement from '../components/statement'
import Complaint from '../components/statement/complaint'
import Aboutas from '../components/statement/aboutAs'

export const router = createHashRouter([
  {
    path: '',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: 'home/:id',
        element: <Details />,
      },
      {
        path: 'window',
        element: <Win />,
      },
      {
        path: 'mac',
        element: <Macsoftware />,
      },
      {
        path: 'game',
        element: <Games />,
      },
      { path: 'window/:id', element: <Details /> },
      { path: 'mac/:id', element: <Details /> },
      { path: 'game/:id', element: <Details /> },
      { path: 'window/:softType/:subSoftType', element: <Win /> },
      { path: 'window/:softType/:subSoftType/:id', element: <Details /> },
      { path: 'mac/:softType/:subSoftType', element: <Macsoftware /> },
      { path: 'mac/:softType/:subSoftType/:id', element: <Details /> },
      { path: 'game/:softType/:subSoftType', element: <Games /> },
      { path: 'game/:softType/:subSoftType/:id', element: <Details /> },

      //关于我们
      { path: 'statement', element: <Statement /> },
      { path: 'complaint', element: <Complaint /> },
      { path: 'about', element: <Aboutas /> },
    ],
  },
])
